module.exports = __webpack_public_path__ + "static/bane_lord_of_darkness-2b5b0cbe66b3df02b7b6f750c78d7ba4.jpg";